import React from "react";
import imgBackgraund from "../assets/portada-web.jpg";

export const LoadingPage = () => {
  return (
    <div
      className="App-body-login"
      style={{
        backgroundImage: `url(${imgBackgraund})`,
        height: "100%",
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      <div className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};
